var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.showProductList == true) ? _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowList),
      expression: "ShowList"
    }],
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter fa-xs",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting d-sm-down-none",
    staticStyle: {
      "padding-right": "10px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.addNewProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getProductDataOnSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.clientProductId'),
      "id": "clientproductid"
    },
    model: {
      value: (_vm.clientproductid),
      callback: function($$v) {
        _vm.clientproductid = $$v
      },
      expression: "clientproductid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('alpha_num'),
      expression: "'alpha_num'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('productid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productID'),
      "id": "productid",
      "name": "productid",
      "minlength": "0"
    },
    model: {
      value: (_vm.productid),
      callback: function($$v) {
        _vm.productid = $$v
      },
      expression: "productid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('common.productName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productNamePlaceHolder'),
      "id": "productname"
    },
    model: {
      value: (_vm.productname),
      callback: function($$v) {
        _vm.productname = $$v
      },
      expression: "productname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.channelName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Chanelsearch),
      expression: "Chanelsearch"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Clientsearch')
    },
    attrs: {
      "name": "Chanelsearch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Chanelsearch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.channelNamePlaceholder')))]), _vm._v(" "), _vm._l((_vm.listfilterChannelData), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.channelid
      }
    }, [_vm._v(_vm._s(warehouse_obj.channelname))])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('productPlaceHolder.productCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productCatPlaceholder'),
      "id": "productname"
    },
    model: {
      value: (_vm.productcategoryname),
      callback: function($$v) {
        _vm.productcategoryname = $$v
      },
      expression: "productcategoryname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('product.productSubCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.productSubCategoryPlaceHolder'),
      "id": "productname"
    },
    model: {
      value: (_vm.productsubcategory),
      callback: function($$v) {
        _vm.productsubcategory = $$v
      },
      expression: "productsubcategory"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFlt
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowList),
      expression: "ShowList"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px",
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-8 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('unicommerce.unicommerceProduct.unicommerceProductList')))])]), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table table-bordered",
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.color')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.size')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.manufacturer')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.mrp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('product.table.columns.hsnCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productTaxPlaceHolder')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.productStock.flipkartid')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.amazonId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.table.action')))])])])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.clientid != '' && (_vm.listProductData && _vm.listProductData.length == 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productListNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listProductData), function(data, index) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.color))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.size))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hsncode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.producttaxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.flipkartid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.amazonid))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "2px",
        "text-align": "center"
      }
    }, [(_vm.viewProductFlag == true) ? _c('span', [_c('i', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          _vm.loadProduct(data)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.editProductFlag == false && _vm.viewProductFlag == false) ? _c('span', [_vm._v("--")]) : _vm._e()])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listProductData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.closeProductModal = false
      }
    },
    model: {
      value: (_vm.productDetailModal),
      callback: function($$v) {
        _vm.productDetailModal = $$v
      },
      expression: "productDetailModal"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Product Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeProductModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.clientProductId')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.clientproductid))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productId')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productid))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productName')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productname))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('errorLogReport.description')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.productdesc))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productCategory')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.category))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productSubCategory')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.subcategory))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.photo')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [(_vm.productDetailData.productimage) ? _c('img', {
    attrs: {
      "src": _vm.productDetailData.productimage,
      "width": "150px"
    },
    on: {
      "error": _vm.imageLoadError
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.brand')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.brand))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.table.columns.color')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.color))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.table.columns.size')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.size))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('clientChannelMaster.createdDateTime')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.createddatetime))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.productStock.flipkartid')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.flipkartid))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cgst')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.cgst))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.sgst')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.sgst))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.igst')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.igst))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('boxList.height')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.height))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.isamazon')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isamazon))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isExpirycontrol')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isexpirycontrol))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.isflipkart')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isflipkart))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isFragile')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isfragile))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.isflipkartsmart')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isflipkartsmart))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLiquid')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.isliquid))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.status')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.status))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.mrp')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.mrp))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.productTaxId')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.producttaxid))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.seller')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.Seller))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.styleCode')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.stylecode))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.taxcode')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.taxcode))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.unitHeightUOM')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.unitheightuom))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.unitLengthUOM')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.unitlengthuom))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.fsn')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.fsn))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.hsn')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.hsn))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productTaxPlaceHolder')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.producttax))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.originCountry')) + ":")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.productDetailData.origincountry))])])])])])])])])])], 1)]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editproductmodal),
      expression: "editproductmodal"
    }]
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editProduct($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.showpoform) ? _c('div', {}, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.editProduct')))]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.showSelectClient) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.client')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client),
      expression: "client"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "client"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clientSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.clientPlaceholder')))]), _vm._v(" "), _vm._l((_vm.listClientData), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.clientid
      }
    }, [_vm._v(_vm._s(client_obj.clientname))])
  })], 2)]), _vm._v(" "), (_vm.client == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ClientErr))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.clientid != '') ? _c('b-tabs', {
    staticClass: "card-header",
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Basic Info",
      "title-link-class": _vm.linkClass(0)
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('merchant.merchantName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.merchantname),
      expression: "addproduct.merchantname"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('merchantname')
    },
    attrs: {
      "type": "text",
      "name": "merchantid",
      "id": "merchantname",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.merchantname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('productPlaceHolder.merchantIdPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listMerchantIdData), function(Merchant_obj) {
    return _c('option', {
      domProps: {
        "value": Merchant_obj.merchantid
      }
    }, [_vm._v(_vm._s(Merchant_obj.merchantname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('merchantid')),
      expression: "errors.has('merchantid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('merchantid')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientproductid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('product.clientProductIdPlaceHolder'),
      "name": "clientproductid",
      "id": "clientproductid",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.clientproductid),
      callback: function($$v) {
        _vm.addproduct.clientproductid = $$v
      },
      expression: "addproduct.clientproductid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientproductid')),
      expression: "errors.has('clientproductid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('clientproductid')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Productname')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productNamePlaceHolder'),
      "name": "Productname",
      "id": "Productname",
      "data-vv-scope": ""
    },
    model: {
      value: (_vm.addproduct.productname),
      callback: function($$v) {
        _vm.addproduct.productname = $$v
      },
      expression: "addproduct.productname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Productname')),
      expression: "errors.has('Productname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Productname')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productDescription')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Productdescription')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('product.productDescriptionPlaceHolder'),
      "name": "Productdescription",
      "id": "Productdescription",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.productdescription),
      callback: function($$v) {
        _vm.addproduct.productdescription = $$v
      },
      expression: "addproduct.productdescription"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Productdescription')),
      expression: "errors.has('Productdescription')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Productdescription')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.productMrp')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('ProductMRP')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.mrpPlaceHolder'),
      "name": "ProductMRP",
      "id": "ProductMRP",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.mrp),
      callback: function($$v) {
        _vm.addproduct.mrp = $$v
      },
      expression: "addproduct.mrp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ProductMRP')),
      expression: "errors.has('ProductMRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ProductMRP')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productTaxPlaceHolder')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Producttax')
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('productPlaceHolder.productTaxPlaceHolder1'),
      "name": "Producttax",
      "id": "Producttax",
      "data-vv-scope": ""
    },
    model: {
      value: (_vm.addproduct.productTax),
      callback: function($$v) {
        _vm.addproduct.productTax = $$v
      },
      expression: "addproduct.productTax"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Producttax')),
      expression: "errors.has('Producttax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Producttax')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.amazonProductId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('amazonProductId')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.amazonProductId'),
      "name": "amazonProductId",
      "id": "amazonProductId",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.amazonProductId),
      callback: function($$v) {
        _vm.addproduct.amazonProductId = $$v
      },
      expression: "addproduct.amazonProductId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amazonProductId')),
      expression: "errors.has('amazonProductId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('amazonProductId')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.FlipkartProductId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('flipkartProductId')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.FlipkartProductIdPlaceholder'),
      "name": "flipkartProductId",
      "id": "flipkartProductId",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.flipkartProductId),
      callback: function($$v) {
        _vm.addproduct.flipkartProductId = $$v
      },
      expression: "addproduct.flipkartProductId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('flipkartProductId')),
      expression: "errors.has('flipkartProductId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('flipkartProductId')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.productCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.productcategoryname),
      expression: "addproduct.productcategoryname"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('productcategoryname')
    },
    attrs: {
      "name": "productcategoryname",
      "id": "productcategoryname",
      "data-vv-scope": "tab1"
    },
    on: {
      "click": _vm.getSubcategoryList,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.productcategoryname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.subCategoryPlaceholder')))]), _vm._v(" "), _vm._l((_vm.listProductCategory), function(Category_obj) {
    return _c('option', {
      domProps: {
        "value": Category_obj.productcategory
      }
    }, [_vm._v(_vm._s(Category_obj.productcategory))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('productcategoryname')),
      expression: "errors.has('productcategoryname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('productcategoryname')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productSubCategory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.productsubcategory),
      expression: "addproduct.productsubcategory"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('subcategoryname')
    },
    attrs: {
      "name": "subcategoryname",
      "id": "subcategoryname",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.productsubcategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productSubCategoryPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listProductsubCategory), function(Subcategory_obj) {
    return _c('option', {
      domProps: {
        "value": Subcategory_obj.productcategory
      }
    }, [_vm._v(_vm._s(Subcategory_obj.productcategory))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subcategoryname')),
      expression: "errors.has('subcategoryname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Product Subcategory field is required")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.brand')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Brand')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.brandPlaceholder'),
      "name": "Brand",
      "id": "Brand",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.brand),
      callback: function($$v) {
        _vm.addproduct.brand = $$v
      },
      expression: "addproduct.brand"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Brand')),
      expression: "errors.has('Brand')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Brand')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('producttype')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.productTypePlaceHolder'),
      "name": "producttype",
      "id": "producttype",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.producttype),
      callback: function($$v) {
        _vm.addproduct.producttype = $$v
      },
      expression: "addproduct.producttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('producttype')),
      expression: "errors.has('producttype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('producttype')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('productPlaceHolder.hsnCodePlaceHolder')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('HSNcode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.hsnCodeHolder'),
      "name": "HSNcode",
      "id": "HSNcode",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.hsncode),
      callback: function($$v) {
        _vm.addproduct.hsncode = $$v
      },
      expression: "addproduct.hsncode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HSNcode')),
      expression: "errors.has('HSNcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HSNcode')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.gstRate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('HSNrate')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.gstraratePlaceHolder'),
      "name": "HSNrate",
      "id": "HSNrate",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.hsnrate),
      callback: function($$v) {
        _vm.addproduct.hsnrate = $$v
      },
      expression: "addproduct.hsnrate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HSNrate')),
      expression: "errors.has('HSNrate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HSNrate')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('i', [(_vm.addproduct.fileupload) ? _c('img', {
    attrs: {
      "src": _vm.addproduct.fileupload,
      "id": "imageEditDisplay",
      "width": "150px"
    },
    on: {
      "error": function($event) {
        _vm.createGoogleLink(_vm.addproduct.fileupload, 'imageEditDisplay')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.filetype),
      expression: "addproduct.filetype"
    }],
    attrs: {
      "type": "radio",
      "value": "Upload"
    },
    domProps: {
      "checked": _vm._q(_vm.addproduct.filetype, "Upload")
    },
    on: {
      "__c": function($event) {
        _vm.addproduct.filetype = "Upload"
      }
    }
  }), _vm._v(_vm._s(_vm.$t('printProductDetails.fileUpload')) + "\n                          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.filetype),
      expression: "addproduct.filetype"
    }],
    attrs: {
      "type": "radio",
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.addproduct.filetype, "url")
    },
    on: {
      "__c": function($event) {
        _vm.addproduct.filetype = "url"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.imageUrl')) + "\n                          ")])], 1), _vm._v(" "), (this.addproduct.filetype == 'url') ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.fileUpload')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('File Upload')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.fileUploadPlaceholder'),
      "name": "File Upload",
      "id": "File Upload",
      "data-vv-scope": "tab1"
    },
    model: {
      value: (_vm.addproduct.fileupload),
      callback: function($$v) {
        _vm.addproduct.fileupload = $$v
      },
      expression: "addproduct.fileupload"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('File Upload')),
      expression: "errors.has('File Upload')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('File Upload')))])], 1)], 1) : _vm._e(), _vm._v(" "), (this.addproduct.filetype == 'Upload') ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productImage')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "Image",
      "value": "",
      "name": "Image",
      "data-vv-scope": "tab1"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('b-button-group', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.validateTab()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.nextBtn')) + " "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Details",
      "title-link-class": _vm.linkClass(1)
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isfragile",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isfragile),
      callback: function($$v) {
        _vm.addproduct.isfragile = $$v
      },
      expression: "addproduct.isfragile"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isFragile')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isflammable",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isflammable),
      callback: function($$v) {
        _vm.addproduct.isflammable = $$v
      },
      expression: "addproduct.isflammable"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.isflammable')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isliquid",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isliquid),
      callback: function($$v) {
        _vm.addproduct.isliquid = $$v
      },
      expression: "addproduct.isliquid"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isLiquid')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "istempsensitive",
      "value": 1
    },
    on: {
      "change": _vm.temsensitiveChange
    },
    model: {
      value: (_vm.addproduct.istempsensitive),
      callback: function($$v) {
        _vm.addproduct.istempsensitive = $$v
      },
      expression: "addproduct.istempsensitive"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isTempSensitive')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "serializecontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.serializecontrol),
      callback: function($$v) {
        _vm.addproduct.serializecontrol = $$v
      },
      expression: "addproduct.serializecontrol"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.serializeControl')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "mfgcontrolled",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.mfgcontrolled),
      callback: function($$v) {
        _vm.addproduct.mfgcontrolled = $$v
      },
      expression: "addproduct.mfgcontrolled"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.isMfgControlled')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "ishazardous",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.ishazardous),
      callback: function($$v) {
        _vm.addproduct.ishazardous = $$v
      },
      expression: "addproduct.ishazardous"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.isHazardous')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "isserialcontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.isserialcontrol),
      callback: function($$v) {
        _vm.addproduct.isserialcontrol = $$v
      },
      expression: "addproduct.isserialcontrol"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.isSerialcontrol')))])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "nocontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.nocontrol),
      callback: function($$v) {
        _vm.addproduct.nocontrol = $$v
      },
      expression: "addproduct.nocontrol"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.noControl')))])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addproduct.nocontrol),
      expression: "addproduct.nocontrol"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "lotcontrol",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.lotcontrol),
      callback: function($$v) {
        _vm.addproduct.lotcontrol = $$v
      },
      expression: "addproduct.lotcontrol"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.lotControl')))])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addproduct.nocontrol),
      expression: "addproduct.nocontrol"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "checkbox"
  }, [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100"
    },
    attrs: {
      "name": "expirycontrolled",
      "value": 1
    },
    model: {
      value: (_vm.addproduct.expirycontrolled),
      callback: function($$v) {
        _vm.addproduct.expirycontrolled = $$v
      },
      expression: "addproduct.expirycontrolled"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.expiryControlled')))])], 1)])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.addproduct.istempsensitive) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.minTemp')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Min Temp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.minTemp'),
      "name": "Min Temp",
      "id": "Min Temp"
    },
    model: {
      value: (_vm.addproduct.mintemp),
      callback: function($$v) {
        _vm.addproduct.mintemp = $$v
      },
      expression: "addproduct.mintemp"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Min Temp')),
      expression: "errors.has('Min Temp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Min Temp')))]), _vm._v(" "), (_vm.ismintempError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.UOMminerrors))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.maxTemp')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Max Temp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.maxTempPlaceholder'),
      "name": "Max Temp",
      "id": "Max Temp"
    },
    on: {
      "keyup": _vm.Checktemp
    },
    model: {
      value: (_vm.addproduct.maxtemp),
      callback: function($$v) {
        _vm.addproduct.maxtemp = $$v
      },
      expression: "addproduct.maxtemp"
    }
  })], 1), _vm._v(" "), (_vm.isError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Qtyerrors))]) : _vm._e(), _vm._v(" "), (_vm.ismaxtempError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.UOMmaxerrors))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.UOMTemp')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thermometer'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.uomtemp),
      expression: "addproduct.uomtemp"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('UOM Temp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.UOMTempPlaceholder'),
      "name": "UOM Temp",
      "id": "UOM Temp"
    },
    domProps: {
      "value": (_vm.addproduct.uomtemp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addproduct.uomtemp = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isuomtempError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.UOMtemperrors))]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.shelfLifeDuration')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shelf Life Duration')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.shelfLifeDurationPlaceHolder'),
      "name": "Shelf Life Duration",
      "id": "Shelf Life Duration"
    },
    on: {
      "keyup": _vm.lifeuom
    },
    model: {
      value: (_vm.addproduct.shelflifeduration),
      callback: function($$v) {
        _vm.addproduct.shelflifeduration = $$v
      },
      expression: "addproduct.shelflifeduration"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Shelf Life Duration')),
      expression: "errors.has('Shelf Life Duration')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Shelf Life Duration')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.ShelfLifeUOM')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-plus-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addproduct.shelflifeuom),
      expression: "addproduct.shelflifeuom"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('shelflifeuom')
    },
    attrs: {
      "name": "shelflifeuom"
    },
    on: {
      "click": _vm.Checkshelfduration,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addproduct.shelflifeuom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.ShelfLifeUOM')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "year"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.year')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "month"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.month')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "day"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.day')))])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shelflifeuom')),
      expression: "errors.has('shelflifeuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.Product.shelflifeError')))]), _vm._v(" "), (_vm.isUOMError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.uomyerrors))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.primaryUom')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Primary Uom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.primaryUomPlaceHolder'),
      "name": "Primary Uom",
      "id": "Primary Uom"
    },
    model: {
      value: (_vm.addproduct.primaryuom),
      callback: function($$v) {
        _vm.addproduct.primaryuom = $$v
      },
      expression: "addproduct.primaryuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Primary Uom')),
      expression: "errors.has('Primary Uom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Primary Uom')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.secondaryUom')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Secondary uom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.secondaryUomPlaceHolder'),
      "name": "Secondary uom",
      "id": "Secondary uom"
    },
    model: {
      value: (_vm.addproduct.secondaryuom),
      callback: function($$v) {
        _vm.addproduct.secondaryuom = $$v
      },
      expression: "addproduct.secondaryuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Secondary uom')),
      expression: "errors.has('Secondary uom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Secondary uom')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(">" + _vm._s(_vm.$t('unicommerce.unicommerceProduct.unitWeight1')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Weight')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.unitWeightPlaceHolder1'),
      "name": "Unit Weight",
      "id": "Unit Weight"
    },
    model: {
      value: (_vm.addproduct.unitweight),
      callback: function($$v) {
        _vm.addproduct.unitweight = $$v
      },
      expression: "addproduct.unitweight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Weight')),
      expression: "errors.has('Unit Weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Unit Weight')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.unitWeightUOM')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Weight uom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.unitWeightUOMPlaceholder'),
      "name": "Unit Weight uom",
      "id": "Unit Weight uom"
    },
    model: {
      value: (_vm.addproduct.unitweightuom),
      callback: function($$v) {
        _vm.addproduct.unitweightuom = $$v
      },
      expression: "addproduct.unitweightuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Weight uom')),
      expression: "errors.has('Unit Weight uom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Unit Weight uom')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.unitDimensonUOM')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Dimenson uom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicommerceProduct.unitDimensonUomPlaceHolder'),
      "name": "Unit Dimenson uom",
      "id": "Unit Dimenson uom"
    },
    model: {
      value: (_vm.addproduct.unitdimensonuom),
      callback: function($$v) {
        _vm.addproduct.unitdimensonuom = $$v
      },
      expression: "addproduct.unitdimensonuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Dimenson uom')),
      expression: "errors.has('Unit Dimenson uom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Unit Dimenson uom')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(">" + _vm._s(_vm.$t('unicommerce.unicommerceProduct.unicommerceUnitLength')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit length')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitLengthPlaceHolder'),
      "name": "Unit length",
      "id": "Unit length"
    },
    model: {
      value: (_vm.addproduct.unitlength),
      callback: function($$v) {
        _vm.addproduct.unitlength = $$v
      },
      expression: "addproduct.unitlength"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit length')),
      expression: "errors.has('Unit length')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Unit length')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.unicommerceUnitBreadth')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Breadth')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitBreadthPlaceHolder'),
      "name": "Unit Breadth",
      "id": "Unit Breadth"
    },
    model: {
      value: (_vm.addproduct.unitbreadth),
      callback: function($$v) {
        _vm.addproduct.unitbreadth = $$v
      },
      expression: "addproduct.unitbreadth"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Breadth')),
      expression: "errors.has('Unit Breadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Unit Breadth')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicommerceProduct.unicommerceUnitHeight')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Unit Height')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitHeightPlaceHolder'),
      "name": "Unit Height",
      "id": "Unit Height"
    },
    model: {
      value: (_vm.addproduct.unitheight),
      callback: function($$v) {
        _vm.addproduct.unitheight = $$v
      },
      expression: "addproduct.unitheight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Unit Height')),
      expression: "errors.has('Unit Height')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Unit Height')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.mfgCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('MFG code')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.mfgCodePlaceHolder'),
      "name": "MFG code",
      "id": "MFG code"
    },
    model: {
      value: (_vm.addproduct.mfgcode),
      callback: function($$v) {
        _vm.addproduct.mfgcode = $$v
      },
      expression: "addproduct.mfgcode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MFG code')),
      expression: "errors.has('MFG code')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MFG code')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.attribute1')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('attribute1')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.attribute1PlaceHolder'),
      "name": "attribute1",
      "id": "attribute1"
    },
    model: {
      value: (_vm.addproduct.attribute1),
      callback: function($$v) {
        _vm.addproduct.attribute1 = $$v
      },
      expression: "addproduct.attribute1"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attribute1')),
      expression: "errors.has('attribute1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('attribute1')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.stickerName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('stickername')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.stickerNamePlaceHolder'),
      "name": "stickername",
      "id": "stickername"
    },
    model: {
      value: (_vm.addproduct.stickername),
      callback: function($$v) {
        _vm.addproduct.stickername = $$v
      },
      expression: "addproduct.stickername"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stickername')),
      expression: "errors.has('stickername')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stickername')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('eancode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.eanCodePHolder'),
      "name": "eancode",
      "id": "eancode"
    },
    model: {
      value: (_vm.addproduct.eancode),
      callback: function($$v) {
        _vm.addproduct.eancode = $$v
      },
      expression: "addproduct.eancode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('eancode')),
      expression: "errors.has('eancode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('eancode')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.subBrand')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('subbrand')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.subBrandPlaceHolder'),
      "name": "subbrand",
      "id": "subbrand"
    },
    model: {
      value: (_vm.addproduct.subbrand),
      callback: function($$v) {
        _vm.addproduct.subbrand = $$v
      },
      expression: "addproduct.subbrand"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subbrand')),
      expression: "errors.has('subbrand')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subbrand')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.size')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('size')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.sizePlaceHolder'),
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.addproduct.size),
      callback: function($$v) {
        _vm.addproduct.size = $$v
      },
      expression: "addproduct.size"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('size')),
      expression: "errors.has('size')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('size')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.table.columns.color')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('color')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.colorPlaceHolder'),
      "name": "color",
      "id": "color"
    },
    model: {
      value: (_vm.addproduct.color),
      callback: function($$v) {
        _vm.addproduct.color = $$v
      },
      expression: "addproduct.color"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('color')),
      expression: "errors.has('color')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('color')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.velocityCode')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('velocitycode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.velocityCodePlaceHolder'),
      "name": "velocitycode",
      "id": "velocitycode"
    },
    model: {
      value: (_vm.addproduct.velocitycode),
      callback: function($$v) {
        _vm.addproduct.velocitycode = $$v
      },
      expression: "addproduct.velocitycode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('velocitycode')),
      expression: "errors.has('velocitycode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('velocitycode')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.unitPrice')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-file'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('unitprice')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.unitPricePlaceHolder'),
      "name": "unitprice",
      "id": "unitprice"
    },
    model: {
      value: (_vm.addproduct.unitprice),
      callback: function($$v) {
        _vm.addproduct.unitprice = $$v
      },
      expression: "addproduct.unitprice"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unitprice')),
      expression: "errors.has('unitprice')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('unitprice')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.UunitHeightUOM')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-arrows-v'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('unitheightuom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.unitHeightUOMPlaceholer'),
      "name": "unitheightuom",
      "id": "unitheightuom"
    },
    model: {
      value: (_vm.addproduct.unitheightuom),
      callback: function($$v) {
        _vm.addproduct.unitheightuom = $$v
      },
      expression: "addproduct.unitheightuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unitheightuom')),
      expression: "errors.has('unitheightuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('unitheightuom')) + "\n                          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.unitLengthUOM')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-arrows-h'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('unitlengthuom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.unitLengthUOMPlaceholer'),
      "name": "unitlengthuom",
      "id": "v"
    },
    model: {
      value: (_vm.addproduct.unitlengthuom),
      callback: function($$v) {
        _vm.addproduct.unitlengthuom = $$v
      },
      expression: "addproduct.unitlengthuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unitlengthuom')),
      expression: "errors.has('unitlengthuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('unitlengthuom')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.unitBreadthUOM')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-arrows-h'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('unitbreadthuom')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.unitBreadthUOMPlaceholder'),
      "name": "unitbreadthuom",
      "id": "unitbreadthuom"
    },
    model: {
      value: (_vm.addproduct.unitbreadthuom),
      callback: function($$v) {
        _vm.addproduct.unitbreadthuom = $$v
      },
      expression: "addproduct.unitbreadthuom"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unitbreadthuom')),
      expression: "errors.has('unitbreadthuom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('unitbreadthuom')) + "\n                          ")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clientfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      disabled: _vm.disableButton
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('common.updateBtn')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))]), _vm._v(" "), _c('div', {
    staticClass: "float-left"
  }, [_c('b-button-group', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.tabIndex = 0
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.previous')))])])], 1)])])], 1) : _vm._e()], 1)])], 1) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showProductList == false) ? _c('div', [_c('div', [_c('newunicommerceproduct', {
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c596cf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c596cf6","hasScoped":true}!./src/views/components/uniware/unicommerceproduct/unicommerceproduct.component.html
// module id = 1902
// module chunks = 0